<template>
    <div class="_MIW" :style="filter">
        <div v-if="svg && loaded" class="_MovingIcon" :style="`background-image: url(https://cdn.jsdelivr.net/npm/movingicons_assets@${version?''+version:'latest'}/svg/${name}.svg)`"></div>
        <LottieAnimation v-else
        :path="`https://cdn.jsdelivr.net/npm/movingicons_assets@${version?''+version:'latest'}/lottie/${name}.json`"
        :icon="name"
        :loop="loop || false"
        :autoPlay="autoplay || false"
        :speed="speed"
        @AnimControl="setController"
        @nojson="nolottie"
        @ready="lottieReady"/>
    </div>
</template>

<script>
    import LottieAnimation from "./LottieAnimation.vue"
    import { AnimationItem } from "lottie-web";
    import FilterFromHex from "./color"

    export default {
        props:{
            properties:{
                type:Object,
                required:false,
            },
            hex:{
                type:String,
                required:false,
            },
            name:{
                type:String,
                required:false
            },
            type:{
                type:String,
                required:false
            },
            animate:{
                type:Boolean,
                required:false
            },
            loop:{
                type:Boolean,
                required:false
            },
            autoplay:{
                type:Boolean,
                required:false
            },
            speed:{
                type:String,
                required:false
            },
            version:{
                type:String,
                required:false
            },
        },
        components:{
            LottieAnimation
        },
        emits:['strings'],
        data: ()=> ({
            svg:false,
            typeDetermined:false, // this exists as not to allow an ambitiously early lottie attempt -- sigh
            controller:undefined,
            loaded:false,
            filter:''
        }),
        mounted(){
            this.isSVG();
            this.getSVG();
            this.getFilter();
        },
        methods: {
            isSVG(){
                if(this.type == 'svg'){
                    this.svg = true;
                }
            },
            getSVG(){
                if(this.svg){
                    let img = document.createElement('img');
                    img.onload = ()=>{
                        this.loaded = true;
                        this.typeDetermined = true;
                    }
                    img.src = `https://cdn.jsdelivr.net/npm/movingicons_assets/svg/${this.name}.svg`;
                }
            },
            nolottie(){
                // fired if the lottieanimation component cannot retieve a json object with provided name and version number
                console.error("Moving Icons Error:", {
                    name:this.name,
                    type:this.type,
                    error:"Could not retrieve lottie .json file",
                    recommendation:"Ensure correct icon name. If no lottie file, then set type as svg"
                });
                this.svg = true;
            },
            lottieReady(){
                this.typeDetermined = true;
            },        
            setController(controller){
                this.controller = controller;
            },
            pause(){
                this.controller.pause();
            },
            play(frame){
                this.controller.goToAndPlay(frame||0);
            },
            getFilter(){
                if(this.hex){
                    let solver = new FilterFromHex(this.hex);
                    let result = solver.solve()
                    this.filter = result.filter;
                }
            }
        },
        watch: {
            // whenever question changes, this function will run
            hex: function (newHex, oldHex) {
                this.getFilter();
            }
        },
    }
</script>

<style scoped>

._MIW{
    height:100%;
    width: 100%;
}
    ._MovingIcon{
        width: 100%;
        height: 100%;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
    }
</style>